import Vue from 'vue'
import App from './view/index/App.vue'
import router from './router'
import Vuex from 'vuex'
import store from '@/store'
// import axios from 'axios'

Vue.use(Vuex)

// import Container, { Loading } from 'element-ui'
import ElementUI from 'element-ui';
// import Table from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'lib-flexible'
// import animate from 'animate.css' //动画 animate.css
import 'animate.css/animate.min.css';
import Video from 'video.js' //视频
import 'video.js/dist/video-js.css'

import './utils/http'  //axios模块
import './utils/element'  // elementui 模块

import './utils/rem.js'; //在main.js中引入rem.js

Vue.config.productionTip = false

// Vue.use( Container )
// Vue.use( Table )
Vue.use(ElementUI);
// Vue.use( animate )
Vue.prototype.$video = Video //在vue的原生里添加了Video这个标签，增强了vue的功能性
//111
// axios.defaults.baseURL = '/api' 
// Vue.prototype.axios = axios

//跨域 统一host路径
Vue.prototype.HOST = '/api';

//111
// //声明请求拦截器
// let loadingInstance = null
// axios.interceptors.request.use(config => {
//   //展示 Loading 效果
//   loadingInstance = Loading.service({ fullscreen: true })
//   return config
// })

// //声明相应拦截器
// axios.interceptors.response.use(response => {
//   //隐藏 Loading 效果
//   loadingInstance.close( 
    
//   )
//   return response
// })


new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
